<template>
  <div class="my-pooq-content-body">
    <router-view name="popupChangePayment"></router-view>
    <div class="mypooq-list">
      <my-pooq-empty-list v-if="showEmptyList" info-text="이용권 결제 내역이 없어요."></my-pooq-empty-list>
      <ul class="mypooq-voucher-list">
        <li v-for="(subscription, index) in subscriptionList" :key="'subscription_' + index"
            :class="subscription.status !== 'y' ? 'expire' : ''">
          <span class="voucher-box">
            <span class="voucher-tag">
              <span class="tag-current" v-if="subscription.status">이용중</span>
            </span>
            <span class="voucher-info">
              <span class="product-txt">{{subscription.productgroupname}}</span>
              <span>{{subscription.productname}}</span>
              <span v-html="replaceDot(subscription.attributetext)"></span>
              <span v-if="subscription.issktstream === 'y'">SKT 안심팩 이용 중</span>
              <span>이용 <i class="icon-dotted"></i> {{subscription.startdate}}</span>
              <span>만료 <i class="icon-dotted"></i> {{subscription.enddate}}</span>
              <span>구매금액 <i class="icon-dotted"></i> {{subscription.amount}}</span>
              <span>다운로드 <i class="icon-dotted"></i> {{download(subscription)}}</span>
              <span>결제방법 <i class="icon-dotted"></i> {{subscription.paymentmethod}}</span>
            </span>
          </span>
          <span class="voucher-change" v-if="subscription.autopayment === 'true' && !subscription.paymentmethod.startsWith('iTunes')">
            <span class="voucher-cancel" v-if="subscription.autopaymentstatus === 'y'" @click.prevent="()=>unsubscribe(subscription)">자동결제 해지</span>
            <span class="voucher-cancel" v-if="subscription.autopaymentstatus === 'n'" @click.prevent="()=>cancelUnsubscribe(subscription)">자동결제 해지 취소</span>
            <span class="method-change" v-if="subscription.changemethod === 'y'" @click.prevent="()=>changePaymentMethod(subscription)">결제수단 변경</span>
          </span>
        </li>
      </ul>
      <div class="partner-info" v-if="subscriptionList && subscriptionList.length > 0">
        wavve 홈페이지가 아닌 제휴 사이트에서 구매한 결합상품(SKT, Bugs에서 구매한 상품 등)의 경우 wavve 사이트에서 해지가 불가능합니다. 제휴사에 문의해주세요.
      </div>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { replace } from 'lodash'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
export default {
  name: 'MyPooqSubscriptionTicket',
  components: {
    MyPooqEmptyList
  },
  data () {
    return {
      subscriptionList: [],
      // dataRevocationDefense: undefined, // 해지 방어 팝업용 데이터
      isUnsubscribe: false, // 해지 방어 팝업용 플래그 true: 1차 해지방어, false: 2차 해지방어
      // isShowRevocationDefense: false, // 해지 방어 팝업 표시 여부
      showEmptyList: false
    }
  },
  methods: {
    setData () {
      MyPooqService.purchaseProduct({
        offset: 0,
        limit: 20,
        orderby: 'new',
        autopayment: 'y',
        producttype: 'pass',
        enddate: '',
        startdate: '',
        device: 'mobile'
      }).then(({ data }) => {
        this.subscriptionList = data.list || []
        this.subscriptionList = this.subscriptionList.map((ticket) => {
          let resTicket = Object.assign({}, ticket)
          let amount = ''
          if (isNaN(ticket.amount)) {
            amount = ticket.amount
          } else {
            amount = ticket.amount + '원'
          }
          resTicket.amount = amount
          return resTicket
        })
        this.showEmptyList = this.subscriptionList.length === 0
      })
    },
    unsubscribe (subscription) {
      this.$router.push({
        name: 'subscription_cancel',
        params: {
          subscription: subscription,
          isUnsubscribe: true
        }
      })
    },
    cancelUnsubscribe (subscription) {
      this.$router.push({
        name: 'subscription_cancel',
        params: {
          subscription: subscription,
          isUnsubscribe: false
        }
      })
    },
    changePaymentMethod (subscription) {
      this.$router.push('/popupChangePayment?transationid=' + subscription.transactionid)
    },
    replaceDot (value) {
      if (value.indexOf('$O$') > -1) {
        return replace(value, new RegExp('\\$O\\$', 'g'), '<i class="icon-dotted"></i>')
      } else {
        return value
      }
    },
    download (subscription) {
      if (+subscription.downloadcount < +subscription.downloadlimit) {
        return +subscription.downloadlimit + '회'
      }
      return '불가'
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
<style scoped>
  .product-name{
    font-size: 12px;
  }
  .voucher-info .product-txt{
    margin-bottom: 10px;
  }
  .voucher-change{
    margin-top: 70px;
  }
  .partner-info{
    position: relative;
    width: 100%;
    margin: 20px 0;
    padding: 0 10px 0 17px;
    font-size: 12px;
    line-height: 14px;
    color: #777;
  }
  .partner-info:before{
    position: absolute;
    top: 6px;
    left: 10px;
    content: '';
    width: 2px;
    height: 2px;
    background-color: #777;
    border-radius: 1px;
  }
</style>
